import { ApolloThunkSubscription } from "../../../../apolloClient/types"
import { apolloSubscription } from "../../../../apolloClient/utils"
import { News } from "../../fragments"
import { SUBSCRIPTION } from "./subscription"

type Data = {
  newsRemoved: News
}

export const subscribeOnNewsRemoved: ApolloThunkSubscription<Data> = (
  state,
  observer,
) => {
  const observable = apolloSubscription<Data, never>({
    state,
    query: SUBSCRIPTION,
  })

  const subscription = observable.subscribe(observer)

  return {
    newsRemovedUnsubscribe: () => subscription.unsubscribe(),
  }
}
